/*eslint-disable */
const $ = window.jQuery = require('jquery');

import bucketTreeView from './tree-view-bucket.vue';
import {
  bus
} from '@/main';
import {
  mapGetters,
} from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'paper-move-to-folder',
  components: {
    'bucket-tree-view' : bucketTreeView
  },
  props: ['paperMoverToFolderDATA'],
  data () {
    return {
      bucketListDetails:null,
      bucketListResults:[],
      selectPaperMoverToFolderData:null,
      selectMoveFolderId:'',
      isSubmitted:false,
      parentDirectory:''
    }
  },
  computed: {
    ...mapGetters([
      'getBucketListOfAwerackGetters',
    ]),
    getBucketListDetailsFun(){
      this.bucketListDetails = this.$store.getters.getBucketListOfAwerackGetters.data;
      return;
    },
    setIntialStateOfBucket(){
      if(this.bucketListDetails){
        this.bucketListResults = this.bucketListDetails.results
      }
    }
  },
  mounted () {
    this.parentDirectory = this.paperMoverToFolderDATA.parent_directory
    this.selectPaperMoverToFolderData = this.paperMoverToFolderDATA
    this.getBucketListDetailsFun
    this.setIntialStateOfBucket
    bus.$on('getSelectFolderID', (data) => {
      this.selectMoveFolderId = data
    })
  },
  methods: {
    getPaperPileListAgain(){
      this.$store.dispatch('getAllPaperPileFun')
    },
    movePaperInParentFolder(){
      this.isSubmitted = true
      let payload = {
        parent: this.selectMoveFolderId,
        pdf_paper:this.selectPaperMoverToFolderData.id,
        is_folder:false
      }
      this.$store.dispatch('createBucketOfAwerackDetailsFun', payload).then((res) => {
        this.isSubmitted = false
        this.getPaperPileListAgain()
        this.paperMoverPopupClosed()
        toast.success(res.data.msg);
      }).catch((err)=>{
        this.isSubmitted = false
        this.paperMoverPopupClosed()
        toast.error(err.data.user_msg || err.data.msg);
      })
      return;
    },
    paperMoverPopupClosed(){
      bus.$emit('paperMoverToFolderBus', false)
      $('body').removeClass('body_right_scroll_remove')
    }
  },
  watch:{
    getBucketListDetailsFun(){
      return this.$store.getters.getBucketListOfAwerackGetters
    },
    setIntialStateOfBucket(){
      if(this.bucketListDetails){
        this.bucketListResults = this.bucketListDetails.results
      }
    }
  }
}